import React from 'react';
import { Package, TrendingUp, Users, ShoppingBag } from 'lucide-react';

const LandingPageStats: React.FC = () => {
  return (
    <div className="py-12 px-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
        <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 transform hover:scale-105 transition-all duration-300">
          <div className="flex items-center mb-4">
            <div className="bg-[#8cc63f] rounded-full p-3 mr-4">
              <Package className="h-6 w-6 text-white" />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-white">200.000+</h3>
              <p className="text-white/80 text-sm">Produtos disponíveis</p>
            </div>
          </div>
          <p className="text-white/70">Acesso a um vasto catálogo de produtos prontos para vender</p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 transform hover:scale-105 transition-all duration-300">
          <div className="flex items-center mb-4">
            <div className="bg-[#8cc63f] rounded-full p-3 mr-4">
              <TrendingUp className="h-6 w-6 text-white" />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-white">40%</h3>
              <p className="text-white/80 text-sm">Margem média</p>
            </div>
          </div>
          <p className="text-white/70">Margens de lucro atrativas para maximizar os seus ganhos</p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 transform hover:scale-105 transition-all duration-300">
          <div className="flex items-center mb-4">
            <div className="bg-[#8cc63f] rounded-full p-3 mr-4">
              <Users className="h-6 w-6 text-white" />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-white">1.000+</h3>
              <p className="text-white/80 text-sm">Vendedores ativos</p>
            </div>
          </div>
          <p className="text-white/70">Junte-se a uma comunidade crescente de empreendedores de sucesso</p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 transform hover:scale-105 transition-all duration-300">
          <div className="flex items-center mb-4">
            <div className="bg-[#8cc63f] rounded-full p-3 mr-4">
              <ShoppingBag className="h-6 w-6 text-white" />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-white">24h</h3>
              <p className="text-white/80 text-sm">Para começar a vender</p>
            </div>
          </div>
          <p className="text-white/70">Comece a vender rapidamente sem investimento inicial em stock</p>
        </div>
      </div>
    </div>
  );
};

export default LandingPageStats;
